import { render, staticRenderFns } from "./AmericasmedicalcityTipoAnestesia.vue?vue&type=template&id=3cfaf910&scoped=true"
import script from "./AmericasmedicalcityTipoAnestesia.vue?vue&type=script&lang=ts"
export * from "./AmericasmedicalcityTipoAnestesia.vue?vue&type=script&lang=ts"
import style0 from "./AmericasmedicalcityTipoAnestesia.vue?vue&type=style&index=0&id=3cfaf910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfaf910",
  null
  
)

export default component.exports